import { Autocomplete, Box, FormHelperText, TextField } from '@mui/material';
import { useField } from 'formik';
import { FieldErrorMessage } from './FieldErrorMessage';

interface AppAutocompleteFieldProps {
  name: string;
  label: string;
  options: readonly string[];
  freeSolo?: boolean;
}

export const AppAutocompleteField = ({
  name,
  label,
  options,
  freeSolo = true
}: AppAutocompleteFieldProps) => {
  const [field, meta, { setValue }] = useField(name);

  const isError = meta.touched && !!meta.error;

  return (
    <Box sx={{ mb: 3, mt: 1 }}>
      <Autocomplete
        data-testid={`${name}-autocomplete-field`}
        sx={{ mb: 1 }}
        value={(field.value as string | null) || ''}
        options={options}
        freeSolo={freeSolo}
        onChange={(_, newValue) => {
          void setValue(newValue || '');
        }}
        renderInput={params => (
          <TextField
            {...params}
            name={name}
            label={label}
            error={isError}
            onBlur={e => {
              field.onBlur(e);
              void setValue(e.target.value);
            }}
          />
        )}
      />
      {isError && (
        <FormHelperText
          sx={{
            mb: 2,
            color: 'red',
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <FieldErrorMessage name={name} />
        </FormHelperText>
      )}
    </Box>
  );
};
